<template>
  <div>
    Araç <br>
    {{Kisi_id}}
  </div>
</template>

<script>
  export default {
    props: ['Kisi_id']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiArac.vue